import React from 'react';

const Span: React.StatelessComponent<any> = ({ className, children, style }) => (
    <span className={className} style={style}>
        {children}
    </span>
);

export default Span;
